export default function TableEmptyState({ colSpan }: { colSpan: number }) {
  return (
    <tr>
      <td colSpan={colSpan} className="p-3 text-center">
        No data found
      </td>
    </tr>
  );
}
